export default "__VITE_ASSET__CO_tqSo2__"